import { State } from 'redux/utils/List'

export default State(
    {
        isFilterOpen: false
    }, {
        isPageable: false,
        isSortable: false,
        isFilterable: true
    }
)
